import {RoleEnum} from "../config/enums/role-enum";

export class Role {

    role: RoleEnum | undefined;
    authority: RoleEnum | undefined;

    constructor(s: string) {
        this.role = RoleEnum[s as RoleEnum];
    }
}
